import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MeasureUnitPage } from './measure-unit.page';
import { MeasureUnitDialogModule } from './measure-unit-dialog/measure-unit-dialog.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';

export * from './measure-unit.page';
export * from './measure-unit-dialog/measure-unit-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: MeasureUnitPage,
    },
];

@NgModule({
    declarations: [ MeasureUnitPage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatFormFieldModule,
        MatIconModule,
        MatProgressBarModule,
        MatTableModule,
        TranslateModule,
        MeasureUnitDialogModule,
        MatPaginatorModule,
        MatInputModule,
        MatButtonModule,
        MatTooltipModule,
        MatSortModule,
    ],
})
export class MeasureUnitPageModule {
}
